import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M79 58c10.49 0 19-8.51 19-19s-8.51-19-19-19-19 8.51-19 19 8.51 19 19 19"
    />
    <path
      fill="#001A43"
      d="M87.25 42.75c0-3.65-2.65-6-6.75-6h-3c-2.25 0-2.25-.98-2.25-1.5s0-1.5 2.25-1.5H84c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25h-2.75V29c0-1.24-1.01-2.25-2.25-2.25s-2.25 1.01-2.25 2.25v.28c-3.67.27-6 2.56-6 5.97 0 3.65 2.65 6 6.75 6h3c2.25 0 2.25.98 2.25 1.5s0 1.5-2.25 1.5H74c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h2.75V49c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-.28c3.67-.27 6-2.56 6-5.97"
    />
    <path fill="#D8FFFF" d="M11.5 79a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m24.12 23 3.94-3.94c.59-.59.59-1.54 0-2.12a1.49 1.49 0 0 0-2.12 0L22 20.88l-3.94-3.94a1.49 1.49 0 0 0-2.12 0 1.49 1.49 0 0 0 0 2.12L19.88 23l-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44L22 25.12l3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM40.5 29a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M98.08 73.45h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57h-5.57c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M71 115c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4M46 43H23.37c-.76 0-1.37.62-1.37 1.37V67h24zM70 43H47.37c-.76 0-1.37.62-1.37 1.37V67h24z"
    />
    <path
      fill="#D8FFFF"
      d="M22 67v22.63c0 .76.62 1.37 1.37 1.37H46V67zM70 67V44.37c0-.76-.62-1.37-1.37-1.37H46v24z"
    />
    <path fill="#00D8D8" d="M46 67v24h22.63c.76 0 1.37-.62 1.37-1.37V67z" />
    <path
      fill="#001A43"
      d="M38 52.75h-1.75V51c0-1.24-1.01-2.25-2.25-2.25s-2.25 1.01-2.25 2.25v1.75H30c-1.24 0-2.25 1.01-2.25 2.25s1.01 2.25 2.25 2.25h1.75V59c0 1.24 1.01 2.25 2.25 2.25s2.25-1.01 2.25-2.25v-1.75H38c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25M37.18 79l1.24-1.24c.88-.88.88-2.3 0-3.18s-2.3-.88-3.18 0L34 75.82l-1.24-1.24c-.88-.88-2.3-.88-3.18 0s-.88 2.3 0 3.18L30.82 79l-1.24 1.24a2.25 2.25 0 0 0 1.59 3.84c.57 0 1.15-.22 1.59-.66L34 82.18l1.24 1.24c.44.44 1.02.66 1.59.66a2.25 2.25 0 0 0 1.59-3.84zM62 57.22h-8c-1.23 0-2.22-.99-2.22-2.22s.99-2.22 2.22-2.22h8c1.23 0 2.22.99 2.22 2.22s-.99 2.22-2.22 2.22M62 77.5h-8a2.5 2.5 0 0 1 0-5h8a2.5 2.5 0 0 1 0 5M62 85.5h-8a2.5 2.5 0 0 1 0-5h8a2.5 2.5 0 0 1 0 5"
    />
  </svg>
);
const SvgEnrichedIconFinancialToolsBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconFinancialToolsBrand);
export default Memo;
